import React from "react";
import {
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia
} from "@material-ui/core";

export const TypeOfStroke = () => {
  return (
    <div>
      <Typography variant="h3">Stroke Type</Typography>
      <Typography variant="body1">There are 3 types of stroke:</Typography>
      <ul>
        <li>
          An <strong>ischemic stroke</strong> occurs when blood clots or other particles block the blood vessels to the
          brain. 87% of 795000 people are ischemic stroke in U.S.A. Ischemia — subtype as
        </li>
        <ul>
          <li>Thrombosis: Thrombus formed in karger vessel or small vessel</li>
          <li>Embolism: multiple acute stroke due to plaques from multiple possible source</li>
          <li>Systemic hypoperfusion</li>
        </ul>
        <li>
          A <strong>hemorrhagic stroke</strong> occurs when a blood vessel bursts in the brain. Blood builds up and
          damages surrounding brain tissue.
        </li>
        <ul>
          <li>Hypertensive ICH</li>
          <li>Bleeding disorder</li>
          <li>
            Lobar or atypical hemorrhage – Amyloid angiopathy, bleeding into a tumor, and vascular malformations or drug
            use
          </li>
        </ul>
        <li>
          <strong>venous thromboembolism</strong>
        </li>
      </ul>
    </div>
  );
};
